import { Injectable } from "@angular/core";
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class SessionTimeoutService {
    public SessionTimeout: BehaviorSubject<boolean>;

    constructor() {
        this.SessionTimeout = new BehaviorSubject<any>(false);
    }
    setSessionTimeout() {
        this.SessionTimeout.next(true);
    }
}



// WEBPACK FOOTER //
// ./client/views/services/session-timeout.service.ts